import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { catchUpInvoicePdfs } from './invoicePdfCatchup';
import { invoicePdfQueue, invoicePdfSession } from './invoicePdfUpload';
// Per session worker prevents StrictMode/remounts from launching duplicate walks.
let running: { epoch: number; promise: Promise<void> } | null = null;
export function useInvoicePdfCatchup(staffId: number | undefined) {
  const client = useQueryClient();
  useEffect(() => {
    const epoch = invoicePdfSession;
    if (staffId == null || running?.epoch === epoch) return;
    const promise = catchUpInvoicePdfs(
      undefined,
      async (invoice, variant) => {
        const ready = await invoicePdfQueue.ensure(invoice, variant);
        if (epoch !== invoicePdfSession) return false;
        await client.invalidateQueries({ queryKey: ['payments', 'invoice-pdf', invoice.id] });
        return ready;
      },
      () => epoch === invoicePdfSession,
    )
      .catch(() => {
        // Listing/network failures must not prevent console use. Missing copies
        // remain visible and retry on the next console opening or staff action.
      })
      .finally(() => {
        if (running?.epoch === epoch) running = null;
      });
    running = { epoch, promise };
  }, [staffId, client]);
}
